import { useEffect, useState } from "react";
import UserFinder from "./userFinder";
import CardList from "../lists/cardList";

const CardPaymentHandler = ({ invoice }) => {
  const [showUserFinder, setShowUserFinder] = useState(false);
  const [userId, setUserId] = useState(null);
  const close = () => {
    setShowUserFinder(false);
  };
  useEffect(() => {
    if (invoice) {
      setShowUserFinder(true);
    }
  }, [invoice]);

  const done = (userId) => {
    setShowUserFinder(false);
    setUserId(userId);
  };
  return (
    <div className="cardPaymentContainer">
      {!userId && showUserFinder && (
        <UserFinder
          open={showUserFinder}
          close={close}
          invoiceId={invoice.id}
          done={done}
        />
      )}
      {userId && (
        <CardList
          merchantId={invoice.merchantId}
          userId={userId}
          invoiceId={invoice.id}
        />
      )}
    </div>
  );
};

export default CardPaymentHandler;

// user check: if invoice has phone find user by phone
// if user hasnot phone ask phone to pay

//if userId found||created check user has pin
//if user has pin ask pin and pay
//if user hasnot pin, set pin by verify phone and pay
